import { createRouter, createWebHistory } from 'vue-router';

import SingleLayout from '@/layout/SingleLayout.vue';
import AppLayout from '@/layout/AppLayout.vue';

import E404Page from '@/page/E404Page.vue';
import BlanckPage from '@/page/BlanckPage.vue';
import HomePage from '@/page/home/HomePage.vue';
import DashboardPage from '@/page/dashboard/DashboardPage.vue';
import DashboardExecutivoPage from '@/page/dashboard/DashboardExecutivoPage.vue';
import DashboardFinanceiroPage from '@/page/dashboard/DashboardFinanceiroPage.vue';

import LoginPage from '@/page/LoginPage.vue';
import EsqueciSenhaPage from '@/page/EsqueciSenhaPage.vue';
import AlterarSenhaPage from '@/page/AlterarSenhaPage.vue';

import UsuarioListaPage from '@/page/usuario/ListaPage.vue';
import SolicitanteListaPage from '@/page/solicitante/ListaPage.vue';
import PendenciaListaPage from '@/page/pendencia/ListaPage.vue';
import PerfilListaPage from '@/page/perfil/ListaPage.vue';

import ClienteListaPage from '@/page/cliente/ListaPage.vue';
import ContaListaPage from '@/page/conta/ListaPage.vue';
import ContaIntegridadeAuditoriaPage from '@/page/conta/IntegridadeAuditoriaPage.vue';
import ExportacaoConsolidadaPage from '@/page/exportacao/ConsolidadaPage.vue';
import ProvedorListaPage from '@/page/provedor/ListaPage.vue';
import ContratoListaPage from '@/page/contrato/ListaPage.vue';
import ContratoVigentePage from '@/page/contrato/VigentePage.vue';
import AgendamentoListaPage from '@/page/contrato/AgendamentoListaPage.vue';
import AprovacaoListaPage from '@/page/aprovacao/ListaPage.vue';
import CotacaoListaPage from '@/page/cotacao/ListaPage.vue';
import LogListaPage from '@/page/log/ListaPage.vue';
import CidadeListaPage from '@/page/cidade/ListaPage.vue';
import EstadoListaPage from '@/page/estado/ListaPage.vue';
import PendenciaCategoriaListaPage from '@/page/pendenciaCategoria/ListaPage.vue';
import ConfiguracaoSistemaPage from '@/page/configuracao/SistemaPage.vue';
import BackupListaPage from '@/page/backup/ListaPage.vue';

import Auth from '@/service/auth.js';

import Token from '@/utils/Token';


const routes = [
    {
        path: '/',
        component: SingleLayout,
        beforeEnter: (to, from, next) => {
            if(Token.get()) {
                return next({ name: 'home'});
            }
            permissoes = {};
            return next();
        },
        children: [
            { path: '', redirect: { name: 'login' } },
            { path: 'login', component: LoginPage, name: 'login' },
            { path: 'esqueci-senha', component: EsqueciSenhaPage, name: 'esqueci-senha' },
            { path: 'alterar-senha/:token', component: AlterarSenhaPage, name: 'alterar-senha' },
            // catch-all por último: se ficar primeiro, pode “engolir” /login e outras rotas públicas
            { path: ':catchAll(.*)', component: E404Page },
        ],
    },
    {
        path: '/app',
        component: AppLayout,
        beforeEnter: (to, from, next) => {
            if(!Token.get()) {
                return next({ name: 'login', query: {error:'auth'} });
            }

            if (Object.keys(permissoes).length === 0) {

                Auth.permissoes()
                    .then(response => {
                        permissoes = response.data;

                        const event = new Event("onPermissios");
                        event.permissoes = permissoes;
                        document.dispatchEvent(event);
                    })
            }
            return next();
        },

        children: [
            { path: '', redirect: { name: 'home' } },

            // Operações
            { path: 'home', component:HomePage, name: 'home' },
            { path: 'dashboard', component: DashboardPage, name: 'dashboard' },
            { path: 'dashboard-executivo', component: DashboardExecutivoPage, name: 'dashboard-executivo' },
            { path: 'contrato', component: ContratoListaPage, name: 'contrato.lista' },
            { path: 'clientes', component: ClienteListaPage, name: 'cliente.lista' },
            { path: 'provedores', component: ProvedorListaPage, name: 'provedor.lista' },
            { path: 'cotacoes', component: CotacaoListaPage, name: 'cotacao.lista' },
            { path: 'pendencias', component: PendenciaListaPage, name: 'pendencia.lista' },
            {
                path: 'cancelamentos/dashboard',
                component: () => import('@/page/cancelamento/DashboardPage.vue'),
                name: 'cancelamento.dashboard',
            },
            {
                path: 'cancelamentos/fila',
                component: () => import('@/page/cancelamento/FilaPage.vue'),
                name: 'cancelamento.fila',
            },
            {
                path: 'cancelamentos/fila/financeiro',
                component: () => import('@/page/cancelamento/FilaFinanceiroPage.vue'),
                name: 'cancelamento.fila.financeiro',
            },
            {
                path: 'cancelamentos/fila/gestao',
                component: () => import('@/page/cancelamento/FilaGestaoPage.vue'),
                name: 'cancelamento.fila.gestao',
            },
            {
                path: 'cancelamentos/tratativa/:id',
                component: () => import('@/page/cancelamento/TratativaPage.vue'),
                name: 'cancelamento.tratativa',
                props: true,
            },
            {
                path: 'cancelamentos/historico',
                component: () => import('@/page/cancelamento/HistoricoPage.vue'),
                name: 'cancelamento.historico',
            },
            {
                path: 'remessas',
                component: () => import('@/page/remessa/ListaPage.vue'),
                name: 'remessa.lista',
            },
            {
                path: 'remessas/criar',
                component: () => import('@/page/remessa/CriarWizard.vue'),
                name: 'remessa.criar',
            },
            {
                path: 'remessas/:id/retorno',
                component: () => import('@/page/remessa/RetornoPage.vue'),
                name: 'remessa.retorno',
                props: true,
            },
            {
                path: 'remessas/:id',
                component: () => import('@/page/remessa/ShowPage.vue'),
                name: 'remessa.show',
                props: true,
            },
            { path: 'agendamentos', component: AgendamentoListaPage, name: 'agendamento.lista' },

            // Financeiro

            { path: 'dashboard-financeiro', component: DashboardFinanceiroPage, name: 'dashboard-financeiro' },
            { path: 'vigentes', component: ContratoVigentePage, name: 'conta.vigentes' },
            { path: 'contas', component: ContaListaPage, name: 'conta.lista' },
            { path: 'contas/integridade', component: ContaIntegridadeAuditoriaPage, name: 'conta.integridade-auditoria' },
            { path: 'exportacao/consolidada', component: ExportacaoConsolidadaPage, name: 'exportacao.consolidada' },

            // Administração
            { path: 'perfis', component: PerfilListaPage, name: 'perfil.lista' },
            { path: 'usuarios', component: UsuarioListaPage, name: 'usuario.lista' },
            { path: 'logs', component: BlanckPage, name: 'log.lista' },
            { path: 'estados', component: EstadoListaPage, name: 'estado.lista' },
            { path: 'cidades', component: CidadeListaPage, name: 'cidade.lista' },
            { path: 'pendencia-categoria', component: PendenciaCategoriaListaPage, name: 'pendencia-categoria.lista' },
            { path: 'solicitantes', component: SolicitanteListaPage, name: 'solicitante.lista' },
            { path: 'aprovacao', component: AprovacaoListaPage, name: 'aprovacao' },
            { path: 'log', component: LogListaPage, name: 'log.lista' },
            { path: 'backups', component: BackupListaPage, name: 'backups.index' },
            {
                path: 'configuracao/sistema',
                component: ConfiguracaoSistemaPage,
                name: 'configuracao.sistema',
                beforeEnter: async (to, from, next) => {
                    try {
                        if (Object.keys(permissoes).length === 0) {
                            const response = await Auth.permissoes();
                            permissoes = response.data;
                            const event = new Event('onPermissios');
                            event.permissoes = permissoes;
                            document.dispatchEvent(event);
                        }
                        return permissoes.CONFIGURACOES_SISTEMA ? next() : next({ name: 'home' });
                    } catch (e) {
                        next({ name: 'login', query: { error: 'auth' } });
                    }
                },
            },
            { path: ':catchAll(.*)', component: E404Page },
        ]
    },
];

const router = createRouter({
  history: createWebHistory(),
  routes,
});

export default router;
